import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import {
  GOOGLE_CLIENT_ID, GoogleAuthService, StandaloneAuthGuardService,
} from '@core/auth';
import { licenseGuard } from '@core/auth/auth-guard/license.guard';
import { ShellComponent } from '@core/shell';
import { botExistGuard } from '@root/pages/bot';
import { redirectGuard } from '@root/pages/redirect';
import { environment } from '@environment';

export const routes: Routes = [
/*  {
    path: 'signin',
    loadComponent: () => import('./pages/signin/signin.component').then(m => m.SigninComponent),
    canMatch: [() => {
      const authGuardService = inject(StandaloneAuthGuardService);
      return authGuardService.signedOutCheck();
    }],
    providers: [
      GoogleAuthService,
      {
        provide: GOOGLE_CLIENT_ID,
        useValue: environment.googleClientId,
      },
    ],
  },*/
  {
    path: 'signin-grpc',
    loadComponent: () => import('./pages/signin-grpc/signin-grpc.component').then(m => m.SigninGrpcComponent),
    canMatch: [() => {
      const authGuardService = inject(StandaloneAuthGuardService);
      return authGuardService.signedOutCheck();
    }],
    providers: [
      GoogleAuthService,
      {
        provide: GOOGLE_CLIENT_ID,
        useValue: environment.googleClientId,
      },
    ],
  },
  {
    // This route is used for redirecting to external urls
    path: 'redirect',
    loadComponent: () => import('./pages/redirect/redirect.component').then(m => m.RedirectComponent),
    canActivate: [redirectGuard],
  },
  {
    path: ':license',
    component: ShellComponent,
    canMatch: [() => {
      const authGuardService = inject(StandaloneAuthGuardService);
      return authGuardService.signedInCheck();
    }],
    canActivate: [
      licenseGuard
    ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent),
      },
      {
        path: 'bot/:botId',
        canActivate: [botExistGuard],
        loadChildren: () => import('./pages/bot/bot.routes').then((m) => m.BOT_ROUTES),
      },
    ]
  },
];
